<template lang="pug">
Layout
   .LoginContainer._relative._mt4
      Loading(v-if="busy" radius)
      ._fs-4._mb2._t-center Sign in
      form(@submit.prevent="handleSubmit")
         label.InputLabel--connected._mb1-5
            .LabelError(v-if="errors.email") {{errors.email}}
            input.Input(tabindex="1" type="text" v-model.trim="credentials.email" placeholder="Type your email address..." autofocus)
            .InputLabel-value._w100 Email address
         label.InputLabel--connected
            .LabelError(v-if="errors.password") {{errors.password}}
            input.Input(tabindex="2" type="password" v-model.trim="credentials.password" placeholder="Type your password...")
            .InputLabel-value._w100._flex._flex-justifySpaceBetween._flex-alignItemsBaseline
               div Password
               router-link._fs-05(tabindex="4" to="/start/") Forgot?
         ._mt2
            ._mb2
               button.Btn.Btn--green._w100(tabindex="3" type="submit") Sign in
               ._my1._lineHeight--1dot4._p05._radius._bg-red-100(v-if="errors.general")
                  ._fs-075._c-red-800 There was a problem. Please check your credentials and try again. 
            ._fs-075._t-center
               | Don't have an account? 
               router-link(tabindex="5" to="/start/") Create one here
</template>

<style lang="sass">
.LoginContainer
   max-width: 330px
   width: 100%
   +mx(auto)
   background-color: white 
   border-radius: $radius 
   +boxShadow--2
   +px($s-1-5)
   +py($s-1-5)
</style>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { validateEmail, validatePassword } from '~/util.js'

export default {
   metaInfo() {
      return {
         title: `Sign In`,
         meta: [
            {
               key: 'description',
               name: 'description',
               content: `View openings with the world's best remote-friendly companies. Find a job with a remote team that exceeds your expectations (so you can exceed theirs).`,
            },
         ],
      }
   },
   data() {
      return {
         busy: false,
         errors: {
            email: null,
            password: null,
            general: false,
         },
         credentials: {
            email: null,
            password: null,
         },
      }
   },
   methods: {
      checkForm() {
         this.errors.general = false

         if (
            this.credentials.email &&
            this.credentials.password &&
            validateEmail(this.credentials.email) &&
            validatePassword(this.credentials.password)
         ) {
            this.errors.email = null
            this.errors.password = null
            return true
         }

         if (!this.credentials.email) {
            this.errors.email = 'Required!'
         } else if (!validateEmail(this.credentials.email)) {
            this.errors.email = 'Seems to be a problem here'
         } else {
            this.errors.email = null
         }

         if (!this.credentials.password) {
            this.errors.password = 'Required!'
         } else if (!validatePassword(this.credentials.password)) {
            this.errors.password = 'Must have at least 6 characters'
         } else {
            this.errors.password = null
         }

         return
      },
      handleSubmit() {
         this.busy = true
         if (!this.checkForm()) {
            this.busy = false
            return
         }

         return this.$store.dispatch('logInMaker', { email: this.credentials.email, password: this.credentials.password }).catch(error => {
            console.error(Error('There was an error'), error)
            this.errors.general = true
            this.busy = false
         })
      },
   },
}
</script>
